import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { UsersPage } from '@/features/admin';
import { workspaceSearchSchema } from '@/patterns';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/_app/admin/users')({
  validateSearch: workspaceSearchSchema.extend({ role: zSearchText(), team: zSearchText(), status: zSearchText(), employment: zSearchText() }),
  staticData: { crumb: 'admin:nav.users' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'admin.users', 'Setup'),
  component: function Users() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return <UsersPage search={search} onSearchChange={(patch, o) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: o?.replace ?? false })} />;
  },
});
